
/* this crutch is here to make it beautiful on the backend */

import { iterateOverFilters } from './utils'

export default {
  middlewareForRequest: ({ loadOptions }) => {
    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      /* TODO перенести в конфиг */
      if (logicalOperator === '=' && filterValue === null) {
        if (paramKeys === 'agents') {
          return ['participantOperators', '=', null]
        }
        if (paramKeys === 'visitor.name') {
          return ['visitor', '=', null]
        }
        if (paramKeys === 'visitor.ipAddress') {
          return ['visitor', '=', null]
        }
        if (paramKeys === 'visitor.calledFrom') {
          return ['visitor', '=', null]
        }
        if (paramKeys === 'visitor.email') {
          return ['visitor', '=', null]
        }
        if (paramKeys === 'visitor.osName') {
          return ['visitor', '=', null]
        }
      }
      if (paramKeys === 'visitor.ipAddress' && logicalOperator === '=' && filterValue === '') {
        return ['visitor', '=', null]
      }
      return [paramKeys, logicalOperator, filterValue]
    })

    return loadOptions
  },

  /* TODO: удалить когда бек сделают */
  middlewareForResponse: ({ transcripts, loadOptions }) => {
    const isRequestForMissingOperators =
      loadOptions.dataField === 'agents' && loadOptions.group[0].selector === 'participantOperators.nickname'
    if (!isRequestForMissingOperators) return transcripts

    let newTranscript = transcripts.filter(transcript => transcript.key !== null)
    return newTranscript
  },
}
